import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import classNames from 'classnames'
import { checkCDN } from 'shared/lib/checkCDN'
import { getAttachmentSizeReserve } from 'entities/Attachment'
import { MessageCardType, type MessageProps } from 'widgets/MessageCard/ui/types'
import { ConversationMessageCardItem } from 'widgets/MessageCard/ui/ConversationMessageCardItem/ConversationMessageCardItem'
import { DateContent } from 'widgets/MessageCard/ui/DateContent/DateContent'
import { BodyRawContent } from 'widgets/MessageCard/ui/BodyRawContent/BodyRawContent'
import { usePresentationModeContext } from 'widgets/PresentationMode'
import styles from './styles.module.scss'

type ITextContentProps = MessageProps & {
  selectedSearch: string
  reserveMediaSize?: boolean
}

export const TextContent: FC<ITextContentProps> = observer((props) => {
  const presentationStore = usePresentationModeContext()
  const { body, previewGifs, undoPending, isFailed, isAudioAttachment } = props.message
  const noPreviews = !previewGifs.length
  const noBody = !body
  const onOpenPresentationOtherAttachments = (index: number) => () => {
    presentationStore.setAttachments(previewGifs, index, true)
  }

  if (noBody && noPreviews && (!isFailed || isAudioAttachment)) return null

  return (
    <ConversationMessageCardItem
      className={classNames({
        [styles.withPreviews]: noPreviews,
        [styles.undoPendingMessage]: undoPending,
      })}
      message={props.message}
      type={previewGifs.length ? MessageCardType.GifPreview : MessageCardType.Text}
    >
      {previewGifs.map((gif, index) => {
        const sizeReserve = props.reserveMediaSize ? getAttachmentSizeReserve(gif) : undefined

        return (
          <img
            key={gif.source}
            {...(checkCDN(gif.source) ? { crossOrigin: 'use-credentials' } : null)}
            src={gif.source}
            alt=''
            className={classNames(styles.img, { [styles.imgReserved]: props.reserveMediaSize })}
            style={sizeReserve}
            onClick={onOpenPresentationOtherAttachments(index)}
            aria-hidden={true}
          />
        )
      })}
      <BodyRawContent message={props.message} selectedSearch={props.selectedSearch} />
      <DateContent {...props} />
    </ConversationMessageCardItem>
  )
})
